import { jsxs as r, jsx as C } from "react/jsx-runtime";
function t(e) {
  return /* @__PURE__ */ r("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M20.75 5.6C20.58 4.82 20.35 4.27 20.05 3.95C19.73 3.62 19.19 3.37 18.43 3.22C17.66 3.07 16.81 3 15.85 3C13.88 3 12.01 3.34 10.24 4.01C8.46 4.68 6.99 5.61 5.8 6.8C4.62 8 3.69 9.48 3.01 11.24C2.34 13 2 14.84 2 16.75C2 17.73 2.08 18.62 2.25 19.4C2.42 20.18 2.65 20.73 2.95 21.05C3.27 21.38 3.81 21.63 4.57 21.77C5.34 21.92 6.19 22 7.15 22C9.12 22 10.99 21.66 12.76 20.99C14.54 20.32 16.01 19.39 17.2 18.2C18.38 17 19.31 15.52 19.99 13.76C20.66 12 21 10.16 21 8.25C21 7.27 20.92 6.38 20.75 5.6ZM19.14 8.77C19.06 10.28 18.72 11.73 18.12 13.14C17.52 14.55 16.73 15.75 15.75 16.74C14.77 17.72 13.57 18.51 12.15 19.11C10.73 19.71 9.24 20.06 7.7 20.14C6.95 20.18 6.28 20.16 5.69 20.07C5.09 19.98 4.68 19.82 4.44 19.57C4.22 19.33 4.06 18.91 3.96 18.3C3.86 17.69 3.83 17 3.87 16.23C3.95 14.72 4.29 13.27 4.89 11.86C5.49 10.45 6.28 9.25 7.26 8.26C8.24 7.28 9.44 6.49 10.86 5.89C12.28 5.29 13.77 4.94 15.31 4.86C16.06 4.82 16.73 4.84 17.32 4.93C17.92 5.02 18.33 5.18 18.57 5.43C18.79 5.67 18.95 6.09 19.05 6.7C19.15 7.31 19.18 8 19.14 8.77Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M7.5 14.5L13.49 8.51C13.75 8.25 14.08 8.12 14.49 8.12C14.9 8.12 15.23 8.25 15.49 8.51C15.75 8.77 15.88 9.1 15.88 9.51C15.88 9.92 15.75 10.25 15.49 10.51L9.5 16.5C9.24 16.76 8.91 16.89 8.5 16.89C8.09 16.89 7.76 16.76 7.5 16.5C7.24 16.24 7.11 15.91 7.11 15.5C7.11 15.09 7.24 14.76 7.5 14.5Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  t as default
};
